import { CartUpdateEvent } from "@gob/events";

class ComponentCartCount extends HTMLElement {
  constructor() {
    super();

    this.el = this;
    this.cart = null;
    this.count = 0;
    this.pad = this.dataset.pad ?? false;

    document.addEventListener(CartUpdateEvent.eventName, this.handleCartUpdate.bind(this));
  }

  handleCartUpdate(event) {
    this.cart = event.cart;

    this.el.textContent = this.pad ? this.cart.item_count.toString().padStart(2, '0') : this.cart.item_count.toString();
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', ComponentCartCount);
}